import { render, staticRenderFns } from "./UploadFile2.vue?vue&type=template&id=1ad146ad&scoped=true&"
import script from "./UploadFile2.vue?vue&type=script&lang=js&"
export * from "./UploadFile2.vue?vue&type=script&lang=js&"
import style0 from "./UploadFile2.vue?vue&type=style&index=0&id=1ad146ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad146ad",
  null
  
)

export default component.exports